"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantHubApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var TenantHubApi = /** @class */ (function (_super) {
    __extends(TenantHubApi, _super);
    function TenantHubApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TenantHubApi.prototype.tenantHubCompaniesIsCompanyCreatedPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/Companies/IsCompanyCreated',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesDisableFeatureForCompanyPost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerDisableFeatureForCompanyRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerDisableFeatureForCompanyRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/DisableFeatureForCompany',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerDisableFeatureForCompanyRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesDisableFeatureForRolePost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerDisableFeatureForRoleRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerDisableFeatureForRoleRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/DisableFeatureForRole',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerDisableFeatureForRoleRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesEnableFeatureForCompanyPost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerEnableFeatureForCompanyRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerEnableFeatureForCompanyRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/EnableFeatureForCompany',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerEnableFeatureForCompanyRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesEnableFeatureForRolePost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerEnableFeatureForRoleRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerEnableFeatureForRoleRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/EnableFeatureForRole',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerEnableFeatureForRoleRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesGetEnabledFeaturesForCompanyPost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerGetEnabledFeaturesForCompanyRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerGetEnabledFeaturesForCompanyRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/GetEnabledFeaturesForCompany',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerGetEnabledFeaturesForCompanyRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesGetEnabledFeaturesForRolePost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerGetEnabledFeaturesForRoleRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerGetEnabledFeaturesForRoleRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/GetEnabledFeaturesForRole',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerGetEnabledFeaturesForRoleRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesGetFeatureEnablementsPost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerGetFeatureEnablementsRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerGetFeatureEnablementsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/GetFeatureEnablements',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerGetFeatureEnablementsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesIsFeatureEnabledForCompanyPost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerIsFeatureEnabledForCompanyRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerIsFeatureEnabledForCompanyRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/IsFeatureEnabledForCompany',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerIsFeatureEnabledForCompanyRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesIsFeatureEnabledForRolePost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerIsFeatureEnabledForRoleRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerIsFeatureEnabledForRoleRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/IsFeatureEnabledForRole',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerIsFeatureEnabledForRoleRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubEnabledFeaturesIsFeatureEnabledForUserPost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerIsFeatureEnabledForUserRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerIsFeatureEnabledForUserRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/EnabledFeatures/IsFeatureEnabledForUser',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerIsFeatureEnabledForUserRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubFeaturesCreateFeaturePost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerCreateFeatureRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerCreateFeatureRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/Features/CreateFeature',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerCreateFeatureRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubFeaturesGetAllFeaturesPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/Features/GetAllFeatures',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubFeaturesGetFeaturePost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerGetFeatureRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerGetFeatureRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/Features/GetFeature',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerGetFeatureRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubUsersGetAllRolesPost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerGetAllRolesRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerGetAllRolesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/Users/GetAllRoles',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerGetAllRolesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TenantHubApi.prototype.tenantHubUsersIsUserCreatedPost = function (_a, opts) {
        var travisBackendControllersTenantHubControllersTenantHubControllerIsUserCreatedRequest = _a.travisBackendControllersTenantHubControllersTenantHubControllerIsUserCreatedRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TenantHub/Users/IsUserCreated',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTenantHubControllersTenantHubControllerIsUserCreatedRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return TenantHubApi;
}(runtime_1.BaseAPI));
exports.TenantHubApi = TenantHubApi;
